import {Fragment, useState} from "react";
import {format} from "date-fns";
import {BreadCrumb, TablePaging, CenteredModal, FormInput} from "~/components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import UserPlanSubscriptionAPI from '~/api/userPlanSubscription';

const breadCrumbItem = [
    { text: "AI Chatbot Page", to: "/ai-chatbot/administrator", isActive: false },
    { text: "User Plan Subscription", to: "", isActive: true },
]
function  UserPlanSubscription() {
    const [reloadTable, setReloadTable] = useState(false);
    const [userPlanSubscriptionDetails, setUserPlanSubscriptionDetails] = useState({});
    const [showModal, setShowModal] = useState(false);
    const tablePagingConfig = {
        columns: [
            {
                name: 'ID',
                width: '70px',
                className: 'fw-bold',
                key: 'UserPlanSubscriptionId'
            },
            {
                name: 'PAYER',
                width: '150px',
                className: 'fw-bold',
                key: 'Payer',
                template: (row) => {
                    return (
                        <div className=" d-flex align-items-center text-body" data-discover="true">
                            <div className="avatar avatar-m">
                                <img alt="avatar" className="rounded-circle" src={row.AvatarUrl}/>
                            </div>
                            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{row.UserName}</p>
                        </div>
                    )
                }
            },
            {
                name: 'SERVICE PLAN',
                width: '120px',
                key: 'ServicePlan'
            },
            {
                name: 'SERVICE TYPE',
                width: '130px',
                key: 'ServiceType'
            },
            {
                name: 'START DATE',
                width: '120px',
                key: 'StartDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.StartDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'END DATE',
                width: '120px',
                key: 'EndDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.EndDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'IS ACTIVE',
                width: '100px',
                key: 'IsActive',
                template: (row) => {
                    return (
                        <span>{row.IsActive ? "Active" : ""}</span>
                    )
                }
            },
            {
                name: 'IS CANCELED',
                width: '110px',
                key: 'IsCanceled',
                template: (row) => {
                    return (
                        <span>{row.IsCanceled ? "Cancled" : ""}</span>
                    )
                }
            },
            {
                name: 'CANCELED AT',
                width: '120px',
                key: 'CanceledAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.CanceledAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'PAYMENT STATUS',
                width: '150px',
                key: 'PaymentStatus'
            },
            {
                name: 'UPDATED AT',
                width: '120px',
                key: 'UpdatedAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.UpdatedAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'CREATED AT',
                width: '120px',
                key: 'CreatedAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.CreatedAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'SUBSCRIPTION MONTHS',
                width: '170px',
                key: 'SubscriptionMonths',
                template: (row) => {
                    return (
                        <span>{row.SubscriptionMonths} months</span>
                    )
                }
            },
            {
                name: 'PRICE PER MONTH',
                width: '150px',
                key: 'PricePerMonth',
                template: (row) => {
                    return (
                        <span>${row.PricePerMonth}</span>
                    )
                }
            },
            {
                name: 'DISCOUNT',
                width: '100px',
                key: 'Discount',
                template: (row) => {
                    return (
                        <span>{row.Discount}%</span>
                    )
                }
            },
            {
                name: 'AMOUNT PAID',
                width: '110px',
                key: 'AmountPaid',
                template: (row) => {
                    return (
                        <span>${row.AmountPaid}</span>
                    )
                }
            },
            {
                name: 'ACTION',
                width: '70px',
                key: 'Action',
                className: 'text-center',
                headerClassName: "text-center",
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handleUserPlanSubscriptionDetail(row.UserPlanSubscriptionId)} icon={faEye} className="text-primary cursor-pointer"/></span>
                    )
                }
            }
        ],
        url: "/user-plan-subscriptions/paged",
        tableKey: "TableUserPlanSubscription",
    }

    const detailFields = [
        {name: "ServicePlan", label: "Service Plan"},
        {name: "ServiceType", label: "Service Type"},
        {name: "StartDate", label: "Start Date"},
        {name: "EndDate", label: "End Date"},
        {name: "CanceledAt", label: "Canceled At"},
        {name: "PaymentStatus", label: "Payment Status"},
        {name: "CreatedAt", label: "Created At"},
        {name: "SubscriptionMonths", label: "Subscription Months"},
        {name: "PricePerMonth", label: "Price Per Month"},
        {name: "Discount", label: "Discount"},
        {name: "AmountPaid", label: "Amount Paid"},
    ]

    const handleUserPlanSubscriptionDetail = (userPlanSubscriptionId) => {
        UserPlanSubscriptionAPI.getById(userPlanSubscriptionId)
            .then((res) => {
                setUserPlanSubscriptionDetails(res.data);
                setShowModal(true);
            })
            .catch((error) => {
                console.error(error);
            })
    }
    return(
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-5 ">User Plan Subscription</h2>
            <TablePaging tablePagingConfig={tablePagingConfig} reloadTable={reloadTable}/>
            <CenteredModal
                show={showModal}
                onClose={() => setShowModal(false)}
                title="User Plan Subscription Details"
                closeText="Close"
                modalType="modal-lg"
            >
                <div className="row">
                    <div>
                        <div className=" d-flex align-items-center text-body justify-content-center flex-column" data-discover="true">
                            <div className="avatar avatar-xl">
                                <img alt="avatar" className="rounded-circle" src={userPlanSubscriptionDetails.AvatarUrl}/>
                            </div>
                            <p className="my-3 text-body-emphasis fw-semibold">{userPlanSubscriptionDetails.UserName}</p>
                        </div>
                    </div>
                    {
                        detailFields.map((item, index) => (
                            <div className="col-sm-6 col-12" key={index}>
                                <FormInput showHeaderLabel={true}
                                           name={item.name}
                                           required={false}
                                           disabled={true}
                                           value={userPlanSubscriptionDetails[item.name]}
                                           label={`Assign ${item.label}`}
                                           maxLengthText=""
                                />
                            </div>
                        ))
                    }
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default UserPlanSubscription;